export default __webpack_public_path__ + "static/blob10-779f987d103f52bc462fa13c855188c9.svg";